import { __rest } from "tslib";
import React from 'react';
import Box from './Box';
import Flex from './Flex';
export default function TwinColumn(_a) {
    var { children, padding } = _a, rest = __rest(_a, ["children", "padding"]);
    return (React.createElement(Flex, Object.assign({ flexDirection: [
            'column-reverse',
            'column-reverse',
            'column-reverse',
            'row',
        ], justifyContent: "stretch", maxWidth: 1024, width: 1 }, rest),
        React.createElement(Box, { p: padding && [1, 2, 3, 4], width: [1, 1, 1, 1 / 2] }, children[0]),
        React.createElement(Box, { p: padding && [1, 2, 3, 4], width: [1, 1, 1, 1 / 2] }, children[1])));
}
TwinColumn.defaultProps = {
    padding: true,
};
